<template>
	<div id="app">
		<Layout class="app-frame" :siderCollapsed="sliderCollapsed" :siderFixed="layoutConfig.siderFixed">
			<Sider :theme="layoutConfig.siderTheme">
				<appMenu :theme="layoutConfig.siderTheme"></appMenu>
			</Sider>
			<Layout :headerFixed="layoutConfig.headerFixed">
				<HHeader theme="white">
					<appHead @openSetting="openSetting=true" :layoutConfig="layoutConfig"></appHead>
				</HHeader>
				<SysTabs v-if="layoutConfig.showSystab" homePage="Home"></SysTabs>
				<Content class="flex flex-column">
					<div v-if="!LOGINSTATUS" class="bg-white-color">
						<Tabs class-name="context-tab h-tabs-card px-8px mt-8px" :datas="tabs" v-model="selectedTab" @clickItem="tabClick">
							<template #item="{tab}">
                <DropdownMenu :datas="contextMenu" @clickItem="trigger" @show="show" trigger="contextMenu" :toggleIcon="false">
                  <span :tabkey="tab.key">{{ tab.title }}</span>
                  <i @click.stop="closeTab(tab.key)" class="h-icon-close-min" v-if="tab.key!=='Home'"></i>
                </DropdownMenu>
							</template>
						</Tabs>

					</div>
					<div class="app-frame-content flex1" style="height: 0;overflow-y: auto">
						<template v-for="tab in tabs">
							<component v-show="currentTab === tab.key" is="ReportView" :is="tab.params.dimension" :dimension="tab.params.dimension" :reportId="tab.params.reportId" v-if="tab.key.startsWith('ReportView')"/>
              <component v-show="currentTab === tab.key" :is="tab.key" :queryId="tab.params?tab.params.queryId:''" :queryStart="tab.params?tab.params.queryStart:''"  :queryEnd="tab.params?tab.params.queryEnd:''" v-else-if="tab.key.startsWith('DetailedAccounts')"/>
              <component v-show="currentTab === tab.key" :is="tab.key" :shiftInsert="tab.params?tab.params.shiftInsert:false" :voucherWord="tab.params?tab.params.voucherWord:''"  :voucherCode="tab.params?tab.params.voucherCode:''" v-else-if="tab.key.startsWith('VoucherForm')"/>
							<component v-show="currentTab === tab.key" :is="tab.key" v-else/>
						</template>
					</div>
				</Content>
			</Layout>
		</Layout>
	</div>
</template>
<script>

	import appHead from './app/app-header';
	import appMenu from './app/app-menu';
	import appFooter from './app/app-footer';
	import {mapGetters, mapMutations, mapState} from 'vuex';
	import SysTabs from './app/sys-tabs/sys-tabs';

	export default {
		name: "FXY",
		data() {
			return {
				openSetting: false,
				selectedTab: "Home",
				isRouterAlive: true,
				layoutConfig: {
					siderTheme: 'dark',
					showSystab: false,
					headerFixed: true,
					siderFixed: true
				},
				LOGINSTATUS: null,
        contextMenu:{
          closeSelf: '关闭标签页',
          closeOther: '关闭其他标签页',
          // closeAll: '关闭所有标签页'
        }
			};
		},
		watch: {
			currentTab(val) {
				this.selectedTab = val;
				localStorage.setItem("currentTab", JSON.stringify(this.tabMap[val]));
				location.hash = val;
			}
		},
		methods: {
			...mapMutations(['changeTab', 'newTab']),
			updateLayoutConfig({key, value}) {
				this.layoutConfig[key] = value;
			},
      show(event) {
        let parent = event.target;
        let tabkey = parent.getAttribute('tabkey') || parent.parentNode.getAttribute('tabkey');
        this.$store.commit('changeTab', tabkey);
      },
      trigger(key, data, event) {
        if (this.currentTab) {
          if (key == 'closeOther') {
            let parent = event.target;
            let tabkey = parent.getAttribute('tabkey') || parent.parentNode.getAttribute('tabkey');
            this.$store.commit('closeOtherTab', this.currentTab);

          } else if (key == 'closeSelf') {
            this.$store.commit('closeTab', this.currentTab);
          }
        }
      },
			closeTab(key) {
				if (key === 'CloseAllTab') {
					// tableData为原数组，row.id为将要删除的对象的id
					// 使用过滤器筛选出id不等于要删除的数据的所有对象，并将其重新赋值给list数组
					this.tableData = this.tabs.filter((item) => {
						return item.key !== 'Home' && item.key !== 'CloseAllTab';
					});
					this.tableData.forEach(item => {
						this.$store.commit('closeTab', item.key);
					})
					this.$store.commit('refreshHomeTab', {key: "Home", title: "首页"})
					this.$store.commit('changeTab', 'Home');
				} else {
					this.$store.commit('closeTab', key);
					if (this.currentTab === 'CloseAllTab') {
						// this.$store.commit('refreshHomeTab', {key: "Home", title: "首页"})
						// this.$store.commit('changeTab', 'Home');
            this.$store.commit('refreshHomeTab', {key: "Voucher", title: "新增凭证"})
            this.$store.commit('changeTab', 'Voucher');
					}
				}
			},
			tabClick({key}) {
				if (key !== 'CloseAllTab') {
					if (this.currentTab !== key) {
						if (key === 'Home') {
							this.$store.commit('refreshHomeTab', {key: "Home", title: "首页"})
						}
						this.$store.commit('changeTab', key);
					}
				}
			}
		},
		computed: {
			...mapState(['sliderCollapsed', 'tabs', 'currentTab', 'menus']),
			...mapGetters(['tabMap'])
		},
		components: {
			appHead,
			appMenu,
			appFooter,
			SysTabs
		},
		created() {
      this.selectedTab = this.currentTab;
			this.LOGINSTATUS = localStorage.getItem("LOGINSTATUS")
			this.currentTabSets = localStorage.getItem("currentTab")
			if (this.currentTabSets && this.currentTabSets!="undefined") {
				this.newTab(JSON.parse(this.currentTabSets));
			}
		}
	};
</script>
<style scoped lang="less">
	.h-icon-close-min {
		margin-left: 10px;
		font-weight: bold;

		&:hover {
			color: #f60 !important;
		}
	}

</style>
